module.exports = __webpack_public_path__ + "img/CV.Earthworks.Site_Clearance.Urban_site_clearance.82a57c72.png";